import { Bandeau, Bouton, Champ, Dialogue } from '@cc/ui';
import { useState } from 'react';
import { requete } from '../../api/client';
import { messageErreur } from '../../api/erreurs';

export function CarteCommercant({ attributionId }: { attributionId: string }) {
  const [ouvert, setOuvert] = useState(false);
  const [portrait, setPortrait] = useState<File | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);
  const produire = async () => {
    if (!portrait) return;
    setEnCours(true);
    setErreur(null);
    try {
      const corps = new FormData();
      corps.set('portrait', portrait);
      const r = await requete<Response>(`/marches/attributions/${attributionId}/carte`, {
        methode: 'POST',
        corps,
        brut: true,
      });
      const url = URL.createObjectURL(await r.blob());
      const lien = document.createElement('a');
      lien.href = url;
      lien.download = `carte-commercant-${attributionId}.pdf`;
      lien.click();
      window.setTimeout(() => URL.revokeObjectURL(url), 10000);
      setOuvert(false);
      setPortrait(null);
    } catch (e) {
      setErreur(messageErreur(e));
    } finally {
      setEnCours(false);
    }
  };
  return (
    <>
      <Bouton variante="secondaire" onClick={() => setOuvert(true)}>
        Carte de commerçant
      </Bouton>
      <Dialogue
        ouvert={ouvert}
        titre="Carte de commerçant"
        description="Choisissez le portrait du commerçant correspondant à cette attribution. La carte porte sa place, sa période et un code QR de vérification."
        onFermer={() => {
          if (!enCours) {
            setOuvert(false);
            setPortrait(null);
          }
        }}
        actions={
          <Bouton disabled={!portrait || enCours} onClick={() => void produire()}>
            Télécharger la carte PDF
          </Bouton>
        }
      >
        <Champ
          type="file"
          accept="image/jpeg,image/png"
          libelle="Portrait du commerçant"
          required
          onChange={(e) => {
            const f = e.target.files?.[0] ?? null;
            setErreur(f && f.size > 5 * 1024 * 1024 ? 'Portrait limité à 5 Mo.' : null);
            setPortrait(f && f.size <= 5 * 1024 * 1024 ? f : null);
          }}
        />
        {erreur ? <Bandeau type="erreur">{erreur}</Bandeau> : null}
      </Dialogue>
    </>
  );
}
